import { LitElement, html, css } from 'lit';
import { customElement } from 'lit/decorators.js';
import { blocks, packageSearch, redo } from '../svg';
import type { CtaCard } from './cards';

@customElement('umb-market-cta')
export class UmbMarketCta extends LitElement {
  #cards: Array<CtaCard> = [];

  connectedCallback() {
    super.connectedCallback();

    this.#cards = [
      {
        title: 'CMS extensions that expand your possibilities',
        subtitle:
          'Explore the many different ways of adding value and functionality to your Umbraco platform.',
        icon: blocks,
        link: '/type/package',
        backgroundColor: 'var(--uui-color-default)',
      },
      {
        title: 'A wide range of integrations',
        subtitle:
          'Discover all the integrations built between Umbraco and various third-party services and compose your DXP.',
        icon: redo,
        link: '/type/integration',
        backgroundColor: 'var(--uui-color-surface)',
      },
      {
        title: 'Find all the Umbraco offerings',
        subtitle:
          'Enhance your DXP with the Umbraco commercial products, open-source integrations, and HQ-supported packages.',
        icon: packageSearch,
        link: '/tag/hq',
        backgroundColor: 'var(--uui-color-current)',
      },
    ];
  }

  render() {
    return html`
      ${this.#cards.map(
        (card, idx) =>
          html`<umb-market-cta-card
            .model="${card}"
            id="cta-${idx}"
          ></umb-market-cta-card>`
      )}
    `;
  }

  static styles = css`
    :host {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: var(--xxl-spacer) 0 0;
      background: var(--uui-color-current-contrast);
      padding: var(--m-spacer) 0;
    }

    :host::before,
    :host::after {
      display: block;
      content: '';
      position: absolute;
      background: var(--uui-color-current-contrast);
      top: 0;
      bottom: 0;
      z-index: -1;
    }

    :host::before {
      left: -100%;
      width: 100%;
    }

    :host::after {
      right: -100%;
      width: 100%;
    }

    umb-market-cta-card + umb-market-cta-card {
      margin-top: var(--m-spacer);
    }

    @media (min-width: 880px) {
      :host {
        display: grid;
        gap: var(--m-spacer);
        grid-auto-columns: 1fr;
        grid-auto-flow: column;
        padding: var(--xl-spacer) 0;
        align-items: unset;
      }

      #cta-0 {
        grid-column: 1 / 2;
        grid-row: 1 / 3;
      }

      #cta-1 {
        grid-column: 2 / 3;
        grid-row: 2 / 4;
      }

      #cta-2 {
        grid-column: 1 / 2;
      }

      umb-market-cta-card + umb-market-cta-card {
        margin-top: 0;
      }
    }

    @media (min-width: 1150px) {
      #cta-0 {
        grid-row: 2 / 6;
        grid-column: 1 / 2;
      }

      #cta-1 {
        grid-row: 1 / 5;
        grid-column: 2 / 3;
      }

      #cta-2 {
        grid-row: 3 / 6;
        grid-column: 3 / 4;
      }
    }

    umb-market-cta-card {
      width: 100%;
      display: block;
      max-width: 550px;
    }
  `;
}
